import videosJson from "@/data/s2pElevateVideos.json";

export interface S2PElevateVideo {
  youtubeId: string;
  title: string;
  duration: string;
  relevance: string;
  visibility: "public" | "unlisted";
}

/* Shared by the Longhand, Serve2Perform, and Rockline decks. Keeping the
   association on stable slide IDs gives every audience the same supporting
   video even when its visible slide title or examples are customized. */
export const S2P_ELEVATE_VIDEOS = videosJson as Record<string, S2PElevateVideo>;
